import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

type ChatSettingsSlice = {
  soundEnabled: boolean;
  toggleSound: () => void;
  // Per-chat mute is stored as the set of explicitly muted chats, so the default
  // (chat not listed) is "unmuted" — the user sees toasts and hears sound until
  // they mute a specific conversation. Client-only (this device), affects the
  // toast + sound only; the unread badge and offline push/email are unaffected.
  mutedChatIds: string[];
  toggleChatMute: (chatId: string) => void;
  isChatMuted: (chatId: string | null | undefined) => boolean;
};

export const useChatSettingsStore = create<ChatSettingsSlice>()(
  persist(
    (set, get) => ({
      soundEnabled: true,
      toggleSound: () => {
        set((state) => ({ soundEnabled: !state.soundEnabled }));
      },
      mutedChatIds: [],
      toggleChatMute: (chatId) => {
        set((state) => ({
          mutedChatIds: state.mutedChatIds.includes(chatId)
            ? state.mutedChatIds.filter((id) => id !== chatId)
            : [...state.mutedChatIds, chatId],
        }));
      },
      isChatMuted: (chatId) => (chatId == null ? false : get().mutedChatIds.includes(chatId)),
    }),
    {
      name: 'chat-settings',
      storage: createJSONStorage(() => localStorage),
    }
  )
);
